import * as protocols from '@/protocols';

export class SocketClient {
    private socket?: WebSocket;
    private retryDelay = 1000;

    // true -> connected, false -> disconnected or connecting
    public onConnect?: (isConnected: boolean) => void;
    public onEvent?: (events: protocols.eventBase[]) => void;

    constructor(private url: string) { }

    public connect() {
        if (this.socket?.readyState === WebSocket.OPEN) {
            return;
        }

        const s = this.socket = new WebSocket(this.url);

        setTimeout(() => {
            if (s.readyState == WebSocket.CONNECTING) {
                s.close();
                this.socket = undefined;
            }
        }, 5000);

        s.onopen = () => {
            this.retryDelay = 1000;
            this.onConnect?.(true);
        };

        s.onmessage = e => {
            const events = JSON.parse(e.data) as protocols.eventBase[];
            this.onEvent?.(events);
        };

        s.onerror = () => {
            s.close();
        };

        s.onclose = () => {
            this.onConnect?.(false);
            this.socket = undefined;
            setTimeout(() => this.connect(), this.retryDelay);
            this.retryDelay = Math.min(this.retryDelay * 2, 30_000);
        };
    }
}
